<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="mx-auto box">
      <v-toolbar class="toolbar" flat dense>
        <v-toolbar-title>
          <strong>Mark Course Attendance</strong>
        </v-toolbar-title>
      </v-toolbar>
      <br />
      <v-card max-width="700" class="mx-auto">
        <v-container fluid>
          <v-row dense align="center">
            <v-card elevation="0" class="mx-auto" max-width="300">
              <v-row align="center">
                <v-card-text class="text-h5 font-weight-bold"
                  >Academic Year&nbsp; : {{ this.ay }}</v-card-text
                >
              </v-row>
            </v-card>
            <v-card elevation="0" class="mx-auto" max-width="300">
              <v-row align="center">
                <v-card-text class="text-h5 font-weight-bold"
                  >Standard &nbsp; : {{ this.standard }}</v-card-text
                >
              </v-row>
            </v-card>
            <v-card elevation="0" class="mx-auto" max-width="300">
              <v-row align="center">
                <v-card-text class="text-h5 font-weight-bold"
                  >Division &nbsp; : {{ this.division }}</v-card-text
                >
              </v-row>
            </v-card>
            <v-card elevation="0" class="mx-auto" max-width="300">
              <v-row align="center">
                <v-card-text class="text-h5 font-weight-bold"
                  >Subject &nbsp; : {{ this.subject }}</v-card-text
                >
              </v-row>
            </v-card>
          </v-row>
        </v-container>
      </v-card>
      <br />
      <v-card >
        <v-card-title >
             Student List
             <v-spacer></v-spacer>
              <v-text-field outlined  rounded dense type="date" v-model="fromdate"></v-text-field>
            <v-spacer></v-spacer>
                <v-btn color="primary" :disabled="this.selectedTasks==''" @click="saveattendance()" :loading="save_loader">Save Attendance</v-btn>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="hw_list"
          :search="search"
          class="mytable"
          v-model="selectedTasks" 
          :single-select="singleSelect"
          show-select 
          :items-per-page="-1"
          item-key="colid"
          >
        >
          <template v-slot:[`item.action`]="{ item }">
            <div>
              <v-btn
                depressed
                color="green"
                :disabled="item.total_submissions == 0"
                @click="evaluate(item)"
                >Evaluation</v-btn
              >
            </div>
          </template>
        </v-data-table>
      </v-card>
    </v-card>
    <!-- <v-overlay :value="overlay">
      <v-progress-circular
        @click="OpenDialog"
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay> -->
  </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css";
import DatetimePicker from "vuetify-datetime-picker";
export default {
  components: { DatetimePicker },
  data() {
    return {
      save_loader:false,
      fromdate: new Date().toISOString().slice(0, 10),
      singleSelect: false,
      selectedTasks: [],
      isvalid:true,Message:null,
      org_id: null,
      link: "",
      not_deleted:true,
      not_deleted_modal_answer:true,
      delete_load:false,
      dialog: false,
      overlay: false,
      snackbar: false,
      search: "",
      snackbar_msg: "",
      color: "",
      snackbar: false,
      ay: null,
      standard: null,
      division: null,
      subject: null,
      hw_list: [],
      date2: new Date().toISOString().substr(0, 10),
      menu: false,
      due_date: null,
      new_due_date: null,
      title: null,
      description: null,
      new_file: null,
      model_answer: null,
      basepath: null,
      // total_marks: 10,
      total_marks: 0,
      edit_dialog:false,
      is_assignment:false,
      headers: [
        {
          text: "Roll. No.",
          value: "stud_rollno",
          align: "center",
        },
        {
          text: "Registration No",
          value: "stud_reg",
          align: "center",
        },
        {
          text: "Name",
          value: "stud_name",
          align: "center",
        },
      ],
      editedItem: {
      homework_id: null,
      title: null,
      description: [],
      due_date: null,
      marks: null,
      attachment: null,
      model_answer: null,
      is_assignment:null,
    },
    };
  },
  mounted() {
    this.getHomeWorkDetails();
    this.basepath = localStorage.getItem("awspath");
    this.org_id = localStorage.getItem("EPS-tenant");
  },
  methods: {
    getDateAttendanceData() {
                const data = {
                    date: this.fromdate,
                    divoff: this.$store.getters.div_off_id,
                    coffid: this.$store.getters.course_off_id,
                    ay: this.$store.getters.ay_id,
                };
                this.save_loader = true;
                this.overlay = true;
                axios
                    .post("/CourseAttendance/getDateAttendanceData", data)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            this.studentinfo = res.data.studentinfo;
                            this.showSnackbar("#4caf50", "Attendance Marked Successfully..."); //res.data.status;
                            this.dayno = res.data.dayno;
                            this.save_loader = false;
                            this.overlay = false;
                            //this.load=true
                        } else {
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    });
    },
    saveattendance() {
                const data = {
                    presentstudent: [],
                    date: this.fromdate,
                    allstudents: [],
                    divoff: this.$store.getters.div_off_id,
                    coffid: this.$store.getters.course_off_id,
                    ay: this.$store.getters.ay_id,
                    dayno: this.dayno,
                };
                var index = 0;
                this.selectedTasks.forEach(function (item) {
                    data.presentstudent[index] = item.colid;
                    index++;
                });
                index = 0;
                this.hw_list.forEach(function (item) {
                    data.allstudents[index] = item.colid;
                    index++;
                });
                this.save_loader = true;
                this.overlay = true;
                axios
                    .post("/CourseAttendance/markCourseAttendance", data)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            this.studentinfo = res.data.studentinfo;
                            //alert("Attendance Marked Successfully")
                            this.showSnackbar("#4caf50", "Attendance Marked Successfully..."); //res.data.status;
                            this.dayno = res.data.dayno;
                            this.save_loader = false;
                            this.overlay = false;
                            //this.load=true
                        } else {
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    });
    },
    formatDate(a, withTime) {
      return withTime
        ? `${a.getFullYear()}-${
            a.getMonth() + 1
          }-${a.getDate()} ${a.getHours()}:${a.getMinutes()}`
        : `${a.getFullYear()}-${a.getMonth() + 1}-${a.getDate()}`;
    },
    save() {
      if (this.title != null) {

        if (this.hasWhiteSpace(this.title)) {
        this.showSnackbar("#b71c1c", "HomeWork Title is compulsory!");
        return;
      }
      if(this.org_id != 'sbpps'){
          if (this.due_date == null || this.due_date=='') {
                  this.showSnackbar("#b71c1c", "Please Select Due Date..!");
                  return;
            }
      }

        this.overlay = true;
        this.dialog = false;
        let formData = new FormData();
        formData.append("courseoffering_id", this.$store.getters.course_off_id);
        formData.append("div_off_id", this.$store.getters.div_off_id);
        formData.append("ay_id", this.$store.getters.ay_id);
        formData.append("title", this.title);
        formData.append("description", this.description);
        formData.append("new_file", this.new_file);
        formData.append("link", this.link);
        formData.append("model_answer", this.model_answer);
        formData.append("total_marks", this.total_marks);
        formData.append("is_assignment", this.is_assignment);
        if (this.due_date != null) {
          var todaysDate = new Date();
          var inputDate = new Date(this.due_date);
          if (
            inputDate.setHours(0, 0, 0, 0) >= todaysDate.setHours(0, 0, 0, 0)
          ) {
            formData.append("due_date", this.formatDate(this.due_date, true));
          } else {
            this.showSnackbar(
              "error",
              "Older date cannot be proceed, Please choose correct date!"
            );
            this.overlay = false;
            this.dialog = true;
            return;
          }
        }
        axios
          .post("/Homework/add_new_homework", formData)
          .then((res) => {
            this.overlay = false;
            if (res.data.flag == "YES") {
              (this.title = null),
                (this.due_date = null),
                (this.description = null),
                (this.new_file = null),
                (this.model_answer = null),
                this.showSnackbar(
                  "#4caf50",
                  "New HomeWork Added successfully!"
                );
              this.getHomeWorkDetails();
            }
            if (res.data.msg == "file_error") {
              this.showSnackbar("#b71c1c", "File not uploaded!");
            }
          })
          .catch((error) => {
            this.overlay = false;
            this.dialog = false;
            let msg = "";
            if (error.response) {
              msg = "Something went wrong.";
            } else if (error.request) {
              msg = "Please try again.";
            } else {
              msg = "Un-expected error.";
            }
          })
          .finally(() => {
            this.overlay = false;
            this.dialog = false;
          });
        // } else {
        //   // this.showSnackbar(
        //   //   "error",
        //   //   "Older date cannot be proceed, Please choose correct date!"
        //   // );
        // }
        //   var todaysDate = new Date();
        //   var inputDate = new Date(this.due_date);
        // if (
        //   inputDate.setHours(0, 0, 0, 0) >= todaysDate.setHours(0, 0, 0, 0) &&
        //   inputDate2.setHours(0, 0, 0, 0) >= todaysDate.setHours(0, 0, 0, 0)
        // ) {
        //   if (
        //     inputDate.setHours(0, 0, 0, 0) > inputDate2.setHours(0, 0, 0, 0)
        //   ) {
        //     // console.log("Wrong!");
        //     this.showsnackbar(
        //       "Start date cannot be bigger than End date, please choose correct date!",
        //       "error",
        //       5000
        //     ); // show snackbar
        //   } else {
        //proceed !!!
        // console.log("Proceed further!");
        // axios
        //   .post("/Homework/add_new_homework", formData)
        //   .then((res) => {
        //     this.overlay = false;
        //     if (res.data.flag == "YES") {
        //       (this.title = null),
        //         (this.due_date = null),
        //         (this.description = null),
        //         (this.new_file = null),
        //         this.showSnackbar(
        //           "#4caf50",
        //           "New HomeWork Added successfully!"
        //         );
        //       this.getHomeWorkDetails();
        //     }
        //     if (res.data.msg == "file_error") {
        //       this.showSnackbar("#b71c1c", "File not uploaded!");
        //     }
        //   })
        //   .catch((error) => {
        //     this.overlay = false;
        //     this.dialog = false;
        //     let msg = "";
        //     if (error.response) {
        //       msg = "Something went wrong.";
        //     } else if (error.request) {
        //       msg = "Please try again.";
        //     } else {
        //       msg = "Un-expected error.";
        //     }
        //   })
        //   .finally(() => {
        //     this.overlay = false;
        //     this.dialog = false;
        //   });
        // }
        // } else {
        //   this.dialog = true;
        //   //wronf date!
        //   //console.log("Wrogn Date!");
        //   this.showsnackbar(
        //     "Older date cannot be proceed, Please choose correct date!",
        //     "error",
        //     5000
        //   ); // show snackbar
        // }
      } else {

        this.dialog = true;
        this.showSnackbar("#b71c1c", "HomeWork Title is compulsory!");
      }




    },
    formatDate2(date2) {
      if (!date2) return null;
      const [year, month, day] = date2.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate2(date2) {
      //console.log(date2)
      if (!date2) return null;
      const [month, day, year] = date2.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    getHomeWorkDetails() {
      if (
        this.$store.getters.course_off_id == null &&
        this.$store.getters.ay_id == null &&
        this.$store.getters.div_off_id == null
      ) {
        this.$router.push({ name: "course-attendance" });
      }
      const data = {
        course_offering_id: this.$store.getters.course_off_id,
        ay_id: this.$store.getters.ay_id,
        div_off_id: this.$store.getters.div_off_id,
      };
      this.overlay = true;
      axios
        .post("/CourseAttendance/getLearners", data)
        .then((res) => {
          this.overlay = false;
          (this.ay = res.data.academic_year),
          (this.standard = res.data.standard),
          (this.division = res.data.division),
          (this.subject = res.data.subject);
          this.hw_list = res.data.ld_list;
        })
        .catch((error) => {
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
};
</script>

<style scoped>

</style>